import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import Page from '@maya/common/Page';
import useTranslate from '@maya/hooks/useTranslate';
import CompanyForm from './CompanyForm';

import type { FC } from 'react';

const NewCompanyView: FC = () => {
  const t = useTranslate();
  const navigate = useNavigate();

  const endEditing = useCallback(() => {
    navigate('/company/list');
  }, [navigate]);

  return (
    <Page title={t('company.view.newHeader')} backTo="/company/list" color="paper">
      <CompanyForm key="editing-form" onClose={endEditing} />
    </Page>
  );
};

export default NewCompanyView;
